import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
var PREFFIX = process.env.VUE_APP_BASE_API || 'vue_app_base_api';
var cacheSessionStorage = {
  set: function set(key, value) {
    sessionStorage.setItem("".concat(PREFFIX, "-").concat(key), JSON.stringify(value));
  },
  get: function get(key, defaultValue) {
    var item = sessionStorage.getItem("".concat(PREFFIX, "-").concat(key)) || defaultValue;
    var data;
    try {
      data = JSON.parse(item);
    } catch (error) {
      data = defaultValue;
    }
    return data;
  },
  remove: function remove(key) {
    sessionStorage.removeItem("".concat(PREFFIX, "-").concat(key));
  }
};
export default cacheSessionStorage;